import { createActivityCommonStore } from "@/app/activity/store"
import { readSessionDataItems } from "@/app/api/session"
import { useSessionDataQuery } from "@/hooks/api/useDataQuery"
import { ActivityData } from "@/types/activity"
import { SessionData } from "@/types/session"
import { useQueries } from "@tanstack/react-query"
import { useEffect } from "react"

export const useClickDataMatchToPlayerAction = (
  idfData: number,
  data: ActivityData,
  isMatched: boolean,
  isChanged: boolean,
  idfActivity: number,
) => {
  const { setPlayerRemoveDialogProps } = createActivityCommonStore((state) => ({
    setPlayerRemoveDialogProps: state.setPlayerRemoveDialogProps,
  }))
  // isMatched가 현재 상태이므로, 체크 해제하려는 경우(isMatched=true)에만 세션 데이터 fetch
  const { data: response, isSuccess } = useSessionDataQuery(
    isMatched && isChanged ? idfData : undefined,
  )
  const { data: participatedSessionList, loaded } = useQueries({
    queries: (response || []).map((session) => ({
      queryKey: ["readSessionDataItems", session.idfSession, idfData],
      queryFn: () => readSessionDataItems(session.idfSession),
      options: {
        enabled: isMatched && isChanged,
      },
    })),
    combine: (results) => {
      return {
        data: results.map((result) => result.data?.response),

        loaded: results.every((result) => result.isSuccess),
      }
    },
  })

  useEffect(() => {
    if (!isChanged) {
      return
    }

    // 체크하려는 경우 (현재 해제 상태): 바로 dialog props 설정
    // 체크 해제하려는 경우 (현재 체크 상태): 세션 데이터 로드 후 dialog props 설정
    if ((loaded && isSuccess) || !isMatched) {
      const sameIdfData = (participatedSessionList || [])
        ?.flat()
        .findIndex((r?: SessionData | null) => r?.idfData === idfData)
      let hasCropRange = false

      if (sameIdfData !== -1) {
        hasCropRange =
          hasCropRange ||
          ((participatedSessionList || []).flat()?.[sameIdfData]?.cropRecords.length as number) > 0
      }

      setPlayerRemoveDialogProps({
        hasCropRange,
        sessionList: (participatedSessionList || []).flat() as SessionData[],
        activityData: data,
        isMatch: !isMatched, // 의도하는 상태 (현재의 반대)
        idfData,
        idfActivity,
      })
    }
  }, [isChanged, loaded, isSuccess, isMatched, response, participatedSessionList])
}
